import { formatCardInfoByLang, queryInfoFromDp } from '@/business';
import { DP_PAGE } from '@/config';
import { MerchantDpList } from '@/types/merchant';
import { DpItem } from '@tencent/wphk-components-dp-loader/src/types';
import { defineStore } from 'pinia';
import { useConfigStore } from './config';

type DpState = {
  /** 页面投放数据是否加载完成 */
  isPageDpInited: boolean;
  /** 页面投放数据 */
  pageDpData: DpItem[];

  /** 商户投放数据是否加载完成 */
  isMerchantInited: boolean;
  /** 商户数据 */
  merchantDpList: MerchantDpList[];
  /** 中国内地-滚动商户列表 */
  mainlainScrollMerchantList: string[];
};

export const useDpStore = defineStore('dp', {
  state: (): DpState => ({
    // 页面投放数据
    isPageDpInited: false,
    pageDpData: [],

    // 商户数据
    isMerchantInited: false,
    merchantDpList: [],
    mainlainScrollMerchantList: [],
  }),
  actions: {
    // 初始化页面 dp 数据
    async initDp() {
      // 重置商户数据
      this.isMerchantInited = false;

      // 获取投放计划
      this.pageDpData = await getDpData();
      this.isPageDpInited = true;
    },
    // 根据位置找到对应的投放计划
    async filterDpDataByPosition({ dpPositionIdList }: { dpPositionIdList: string[] }): Promise<DpItem[]> {
      if (!dpPositionIdList || !dpPositionIdList.length) return [];
      // 获取对应位置的投放计划
      return this.pageDpData.filter(ele => dpPositionIdList.includes(ele.dpPosition)) || [];
    },
    // 中国内地 获取 wuji 滚动商户信息
    async initWujiScrollMerchant() {
      // 获取滚动的商户列表 - 来自无极
      const merchantList = await getMerchantScrollList();
      this.mainlainScrollMerchantList = merchantList;
    },
    // 获取 wuji 推荐商户配置
    async initWujiRecommendMerchant() {
      const recommendMerchantList = await getMerchantRecommendList();
      this.merchantDpList = recommendMerchantList;
      // 处理完成
      this.isMerchantInited = true;
    },
  },
});

/**
 * 获取投放计划
 * @returns
 */
async function getDpData(): Promise<DpItem[]> {
  const { currentAreaAllDpPos } = useConfigStore();
  return queryInfoFromDp(DP_PAGE, currentAreaAllDpPos);
}

/** 中国内地-滚动热门商户配置 */
async function getMerchantScrollList(): Promise<string[]> {
  const { getCurrentWujiConfig } = useConfigStore();
  const currentWujiConfig = await getCurrentWujiConfig();
  return currentWujiConfig?.hotMerchantListV2?.list || [];
}
/** 热门商户配置 */
async function getMerchantRecommendList() {
  const { getCurrentWujiConfig } = useConfigStore();
  const currentWujiConfig = await getCurrentWujiConfig();
  return (currentWujiConfig?.recommendMerchantList || []).map(ele => ({
    ...formatCardInfoByLang(ele),
    contentPosition: String(ele.id),
    isHomeShow: !!ele.isHomeShow,
  }));
}
/** 中国澳门-旅行好助手 */
export async function getTravelAssistant() {
  const { getCurrentWujiConfig } = useConfigStore();
  const currentWujiConfig = await getCurrentWujiConfig();
  return formatCardInfoByLang(currentWujiConfig?.travelAssistant || []);
}
